// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"4dc1f1c4","453":"0ddd8a3a","777":"3d67456b"}[chunkId] + ".chunk.js";
};